import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SelectFundusCamera = ({ open, handleClose, handleSave, cameras }) => {
  const [selectedCamera, setSelectedCamera] = useState("");

  useEffect(() => {
    if (open && cameras.length > 0) {
      const previouslySelected = localStorage.getItem("fundusCamera");
      setSelectedCamera(previouslySelected || "");
    }
  }, [open, cameras]);

  const handleCameraSelect = (event) => {
    const selectedId = event.target.value;
    setSelectedCamera(selectedId);
  };

  const handleContinue = () => {
    if (selectedCamera) {
      handleSave(selectedCamera);
    }
  };

  return (
    <Dialog open={open} sx={dialogStyles}>
      <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
        <Typography color="#0D1E83">Select Fundus Camera</Typography>
        <Button endIcon={<CloseIcon />} onClick={handleClose} sx={{ color: "#0D1E83" }} />
      </DialogTitle>
      <DialogContent>
        <Typography>Fundus Camera*</Typography>
        <Select
          fullWidth
          value={selectedCamera}
          onChange={handleCameraSelect}
          displayEmpty
          renderValue={(selected) => {
            const selectedCamera = cameras.find((camera) => camera.id === selected);
            return selectedCamera ? (
              <Box display="flex" flexDirection="column">
                <Typography variant="body1">{selectedCamera.camera_name}</Typography>
              </Box>
            ) : (
              <Typography variant="body1">Select Camera</Typography>
            );
          }}
        >
          <MenuItem value="" disabled>Select Camera</MenuItem>
          {(cameras || []).map((camera) => (
            <MenuItem key={camera.id} value={camera.id}>
              <Box display="flex" flexDirection="column">
                <Typography variant="body1">{camera.camera_name}</Typography>
                <Typography variant="body2" sx={{ color: 'gray' }}>
                  {camera.camera_serial_number}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-evenly" alignItems="center" width="100%">
          <Button sx={{ color: "#9F0101", border: "2px solid #9F0101", borderRadius: "8px", textTransform: "none" }} onClick={handleClose}>
            Exit
          </Button>
          <Button
            sx={{
              background: "linear-gradient(270deg, #051572 0%, #0820B4 100%)",
              border: "1px solid #0D1E83",
              borderRadius: "8px",
              color: "#FFF",
              "&.Mui-disabled": {
                background: "#B0B0B0",
                color: "#FFF",
                textTransform: "none"
              },
            }}
            onClick={handleContinue}
            disabled={!selectedCamera}
          >
            Continue
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SelectFundusCamera;

const dialogStyles = {
  "& .MuiDialog-paper": {
    width: "90%",
    maxWidth: "400px",
    height: "auto",
    borderRadius: "16px",
    padding: "16px",
    "@media (max-width: 600px)": {
      width: "95%",
      maxWidth: "350px",
    },
    "@media (min-width: 900px)": {
      width: "450px",
      maxWidth: "500px",
    },
  },
};
